<template>
  <div
    ref="lf"
    class="lf"
  >
    <div
      class="lfi-container"
      @click="isOpened = true"
    >
      <input
        class="lfi"
        :value="currentLocaleLabel"
        id="language-field"
      >
      <svg
        class="lfi-icon"
        width="9"
        height="6"
        viewBox="0 0 9 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.865 1.284L4.432 4.716L1 1.284"
          stroke="#747474"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <div
      v-show="isOpened"
      class="lf-content"
    >
      <ul class="lf-list">
        <li
          v-for="locale in locales"
          :key="locale.name"
          class="lf-list-item"
          @click="switchLocale(locale.value)"
        >
          {{ locale.label }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {
  ENGLISH_APP_PATH_NAME,
  SLOVAK_APP_PATH_NAME,
} from '@/config';
import stepsRoutes from '@/router/stepsRoutes';

export default {
  name: 'LanguageField',
  data() {
    return {
      isOpened: false,
    };
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  computed: {
    locales() { return JSON.parse(process.env.VUE_APP_I18N_SUPPORTED_LOCALES); },
    currentLocale() { return process.env.NODE_ENV === 'production' ? process.env.LOCALE : process.env.VUE_APP_I18N_FALLBACK_LOCALE; },
    currentLocaleLabel() {
      return this.locales.find((locale) => locale.value === this.currentLocale).label;
    },
    contexts() {
      return {
        sk: SLOVAK_APP_PATH_NAME,
        en: ENGLISH_APP_PATH_NAME,
      };
    },
    queryParamsString() {
      const entries = Object.entries(this.$route.query);

      if (!entries.length) return '';

      return entries.reduce((acc, query, index) => {
        const [key, value] = query;
        acc += `${key}=${encodeURIComponent(value.toString())}`;
        if (index !== entries.length - 1) acc += '&';
        return acc;
      }, '?');
    },
  },
  methods: {
    switchLocale(locale) {
      this.isOpened = false;
      if (locale !== this.currentLocale) {
        const context = this.contexts[locale];

        const step1Route = stepsRoutes.find((route) => route.meta?.step === 1);
        let localeStepPath = step1Route.path;

        if (locale !== process.env.VUE_APP_I18N_FALLBACK_LOCALE) {
          localeStepPath = step1Route.meta[`path${locale.toUpperCase()}`];
        }

        if (locale === 'en') {
          localeStepPath = '/selection-of-insured-person';
        } else if (locale === 'ua') {
          localeStepPath = '/vybir-osoby-shcho-strakhuietsia';
        }

        window.location.href = `${window.location.origin}/${context}/#${localeStepPath}${this.queryParamsString}`;
      }
    },
    handleClickOutside(event) {
      if (
        this.$refs.lf
              && !this.$refs.lf.contains(event.target)
      ) {
        this.isOpened = false;
      }
    },
  },
};
</script>
